import React, { useState, useEffect } from 'react';
import { get, post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from '../icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import Breadcrumb from '../../components/Breadcrumb';

const Products = () => {
  const formFields = {
    name: '',
    festCategoryId: '',
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [productList, setProductList] = useState([]);
  const [formDetails, setFormDetails] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [query, setQuery] = useState('');
  const [categoryList, setCategoryList] = useState([]);
  const [categoryWiseList, setCategoryWiseList] = useState([]);

  const handleShow = () => {
    setShowConfirmModel(true);
    setFormDetails(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/fest/products/?id=' + id).then((item) => {
        if (item?.data?.rows?.length) {
          const itemData = item.data.rows[0];
          setFormDetails({ ...itemData });
          setShowConfirmModel(true);
        } else {
          toast.error('Invalid Category id');
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    let _formDetails = { ...formDetails, [name]: value };
    setFormDetails(_formDetails);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in formDetails) {
      try {
        await put(formDetails, '/fest/products/' + formDetails.id);
        toast.success('Product updated successfully');
        setShowConfirmModel(false);
        getProducts();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
      }
    } else {
      try {
        await post(formDetails, '/fest/products');
        toast.success('Product added successfully');
        setShowConfirmModel(false);
        getProducts();
      } catch (err) {
        toast.error(err.response.data.message || err.response.data.data.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getProducts() {
    try {
      get(`/fest/products/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setProductList(response.data.rows);
        setTotalRecords(response.data.count ?? 0);
        const _products = response.data.rows;
        const productsByCategory = {};
        _products.forEach((product) => {
          const categoryName = product['Category.name'];
          if (!productsByCategory[categoryName]) {
            productsByCategory[categoryName] = [];
          }
          productsByCategory[categoryName].push(product);
        });
        const productsGroupedByCategory = Object.entries(productsByCategory).map(([category, products]) => ({
          category,
          products,
        }));
        setCategoryWiseList(productsGroupedByCategory);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  function getCategories() {
    try {
      get(`/fest/category/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setCategoryList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getProducts();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getProducts();
    getCategories();
  }, []);

  const handleSelect = (e) => {
    const { value, name } = e.target;
    setFormDetails((state) => {
      return { ...state, [name]: value };
    });
  };

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Festival' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Products' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Products | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Product
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>Product Name</th>
                    <th>Created By</th>
                    <th>Updated By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryWiseList?.map((item, index) => {
                    return (
                      <>
                        <tr key={item?.id}>
                          <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td rowSpan={item.products.length}>{item.category}</td>
                          <td>{item?.products[0].name}</td>
                          <td>{item.products[0]['createdByUser.name'] || '-'}</td>
                          <td>{item.products[0]['updatedByUser.name'] || '-'}</td>
                          <td className="actions">
                            <span className="edit-icon" onClick={(e) => handleEdit(e, item.products[0]?.id)}>
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                          </td>
                        </tr>
                        {item.products?.slice(1)?.map((data, index2) => {
                          return (
                            <tr>
                              <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + index2 + 1)}</td>
                              <td>{data.name}</td>
                              <td>{data['createdByUser.name'] || '-'}</td>
                              <td>{data['updatedByUser.name'] || '-'}</td>
                              <td className="actions">
                                <span className="edit-icon" onClick={(e) => handleEdit(e, data?.id)}>
                                  <EditIcon style={{ color: 'teal' }} />
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in formDetails ? 'Edit Product' : 'Add Product'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={6}>
                <FloatingLabel label="Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="name"
                    onChange={handleChange}
                    value={formDetails.name}
                    type="text"
                    placeholder="Name"
                    required
                    autoComplete="false"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel label="Category" className="mb-3">
                  <select
                    required
                    name="festCategoryId"
                    value={formDetails.festCategoryId}
                    onChange={handleSelect}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option value="">Select Category</option>
                    {categoryList.map((item, index) => (
                      <option key={index} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                {'id' in formDetails ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Products;
